import IsLoading from "@/components/layouts/IsLoading";
import TrialContext from "@/contexts/data/TrialContext";
import useTrialStatuses from "@/hooks/data/useTrialStatuses";
import { Alert, AlertTitle, Box, Chip, Divider, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableHead, TableRow, Theme, Tooltip, TooltipProps, Typography, darken, lighten, styled, tooltipClasses, useTheme } from "@mui/material";
import { FC, Fragment, ReactNode, useCallback, useContext, useMemo } from "react";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faCommentAlt, faCommentCaptions, faExclamationCircle, faFileCheck, faFileMagnifyingGlass } from "@fortawesome/pro-duotone-svg-icons";
import { green, grey, red, yellow } from "@mui/material/colors";
import StatusList from "@/components/lists/status/StatusList";
import useParticipants from "@/hooks/data/useParticipants";
import useParticipantStatuses from "@/hooks/data/useParticipantStatuses";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import Show from "@/components/layouts/Show";
import { AppSettings } from "@/AppSettings";
import { CoordinatingGroup, Institution, MasterGroup, Participant, UpdateStatusEvent } from "@/api/dtos";
import { StatusListItemTooltip, StatusListItemTooltipStats } from '@/components/lists/status/StatusListStats';
import { DateTime } from 'luxon';
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import SetLinks from "@/components/layouts/SetLinks";
import { ConfigurationParticipantsInstitutionCreateLink, ConfigurationParticipantsParticipantCreateLink, ConfigurationParticipantsTrialCreateLink, ParticipantInstitutionCreateLink, ParticipantTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import MasterGroupsContext from "@/contexts/data/MasterGroupsContext";
import CoordinatingGroupsContext from "@/contexts/data/CoordinatingGroupsContext";
import ConfigurationList from "@/components/lists/configuration/ConfigurationList";
import { IConfigurationListItem, IConfigurationStatComponentProps } from "@/components/lists/configuration/ConfigurationListItem";
import { IConfigurationListSortable, DefaultSortableFields } from "@/components/lists/configuration/ConfigurationListSort";
import ParticipantsContext from "@/contexts/data/ParticipantsContext";
import ParticipantConfigurationList from "@/components/lists/status/ParticipantConfigurationList";


const ConfigurationParticipants: FC = () => {
    const { data: participants } = useContext(ParticipantsContext);

    const loading = false;
    const validating = false;

    return (
        <>
            <SetLinks 
                createTrialLink={ConfigurationParticipantsTrialCreateLink} 
                createInstitutionLink={ConfigurationParticipantsInstitutionCreateLink}
                createParticipantLink={ConfigurationParticipantsParticipantCreateLink}
            />
            <IsLoading name="configuration-participants-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Configuration &mdash; Participants
                </Typography>
                <ParticipantConfigurationList 
                    data={participants}
                />
            </Show>
        </>
    )
};

export default ConfigurationParticipants;